import api from './api';

export default class DependenciasService {
  constructor() {
    throw 'Não é possível instanciar DependenciasService';
  }

  static async lista() {
    const endpoint = mergeEndpoint();
    return await api.get(endpoint);
  }

  static async grava(dependencia) {
    const endpoint = mergeEndpoint();
    return await api.post(endpoint, dependencia);
  }

  static async atualiza(id, dependencia) {
    const endpoint = mergeEndpoint(id);
    return await api.put(endpoint, dependencia);
  }

  static async apaga(id) {
    const endpoint = mergeEndpoint(id);
    return await api.delete(endpoint);
  }

  static async obtemDependente(cpf) {
    const endpoint = mergeEndpoint(cpf);
    return await api.get(endpoint);
  }
}

const mergeEndpoint = value => {
  return `dependentes/${value || ''}`;
};



// WEBPACK FOOTER //
// ./src/services/dependenciasService.js